import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/aiWand.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M14.288 2.882a.5.5 0 0 1 .71 0l2.12 2.122c.095.094.146.22.146.354s-.051.26-.146.355l-14.14 14.14a.5.5 0 0 1-.354.146.5.5 0 0 1-.354-.145L.148 17.73a.5.5 0 0 1 0-.709zM18 7c0 1.106.894 2 2 2-1.106 0-2 .893-2 1.999A1.997 1.997 0 0 0 16 9c1.106 0 2-.894 2-2m-6.704.295 1.413 1.413 3.35-3.35-1.412-1.413zM11.001 0c0 1.106.893 2 2 2-1.107 0-2 .894-2 2a2 2 0 0 0-2-2c1.106 0 2-.894 2-2m7 0c0 1.106.893 2 2 2-1.107 0-2 .894-2 2 0-1.106-.895-2-2-2 1.105 0 2-.894 2-2",
		clipRule: "evenodd"
	})
});
//#endregion
export { t as default };
